import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { timeToMinutes } from 'Data/format.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
  })
  let upcomingAppointment = useDataValue({
    context: 'upcoming_appointment',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'setExistingAppointment',
      id: upcomingAppointment.appointment._id,
      type_id: upcomingAppointment.appointment.type._id,
      type_name: upcomingAppointment.appointment.type.display_name,
      treatment_id: upcomingAppointment.appointment.tx._id,
      duration: upcomingAppointment.duration,
      approximateDate: null,
      location: {
        id: upcomingAppointment.location._id,
        vaxiom_id: upcomingAppointment.location.id,
        name: upcomingAppointment.location.name,
        time_zone_id: upcomingAppointment.location.time_zone_id,
      },
      booking: {
        start_min: timeToMinutes(upcomingAppointment.local_start_time),
        date: upcomingAppointment.local_start_date,
        chair_id: upcomingAppointment.chair._id,
        chair_name: upcomingAppointment.chair.full_name,
        location_id: upcomingAppointment.location._id,
      },
    })

    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
